import Vue from 'vue';
import Meta from 'vue-meta';

Vue.use(Meta);
